import api from "./Api";

class OrdemServicoAgendamentoService {
  GetCalendario(payload) {
    const params = new URLSearchParams();

    if (payload?.dataInicio) {
      params.append("dataInicio", payload.dataInicio);
    }

    if (payload?.dataFim) {
      params.append("dataFim", payload.dataFim);
    }

    return api
      .get(`/v1/OrdemServicoAgendamento/Calendario?${params.toString()}`)
      .then((response) => response.data);
  }

  GetOrdemServicoAgendamento(payload) {
    return api
      .get(`/v1/OrdemServicoAgendamento/${payload}`)
      .then((response) => {
        return response.data;
      });
  }

  GetHistoricoCliente(payload) {
    const params = new URLSearchParams();

    if (payload?.limite) {
      params.append("limite", payload.limite);
    }

    if (payload?.ignorarAgendamentoId) {
      params.append("ignorarAgendamentoId", payload.ignorarAgendamentoId);
    }

    return api
      .get(
        `/v1/OrdemServicoAgendamento/HistoricoCliente/${
          payload.idCliente
        }?${params.toString()}`
      )
      .then((response) => {
        return response.data;
      });
  }

  PutReagendar(payload) {
    return api
      .put("/v1/OrdemServicoAgendamento/Reagendar", payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new OrdemServicoAgendamentoService();
